module.exports = __webpack_public_path__ + "static/media/addFile.dd65d4dc.svg";